const BreakLine = () => (
  <div
    className="w-full"
    style={{
      height: "1px",
      backgroundImage: "repeating-linear-gradient(to right, #EAECF0, #EAECF0 6px, transparent 6px, transparent 14px)"
    }}
  />
);

export default BreakLine;
